export default __webpack_public_path__ + "static/facts-categories-801aeb9aee23161d1f84463cc5e4c55d.webp";